import { render, staticRenderFns } from "./Recruitments.vue?vue&type=template&id=b23a300e&"
import script from "./Recruitments.vue?vue&type=script&lang=js&"
export * from "./Recruitments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports